/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import * as St from "./styles";
import Chronometer from "./components/Chronometer";
import { WhiteFlash } from "./components/WhiteFlash";
import { getDataURI, playClickAudio } from "./helpers";
import Button from "~/components/Button";
import themes from "~/themes";

export const FACING_MODES = {
  ENVIRONMENT: "environment",
  USER: "user",
};

if (navigator.mediaDevices.getUserMedia === undefined) {
  navigator.mediaDevices.getUserMedia = function (constraints) {
    var getUserMedia =
      navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

    if (!getUserMedia) {
      return Promise.reject(
        new Error("getUserMedia is not implemented in this browser")
      );
    }

    return new Promise(function (resolve, reject) {
      getUserMedia.call(navigator, constraints, resolve, reject);
    });
  };
}

function CameraLending(
  {
    open,
    handleClose,
    onTakePhoto,
    isStartLiveness,
    isLiveness = false,
    mask,
    doNotCloseAfterTakePicture,
    certifaceMessagebase64,
    disableCloseButton,
    disableChangeCamButton,
    disableTakePictureButton,
    facingMode = FACING_MODES.ENVIRONMENT,
    stopWatch = false,
  },
  ref
) {
  const [cameraType, setCameraType] = useState(facingMode);
  const [isFaceMatch, setIsFaceMatch] = useState(false);
  const [isShowWhiteFlash, setIsShowWhiteFlash] = useState(false);
  const [messageImage, setMessageImage] = useState(
    certifaceMessagebase64 || null
  );

  const isChronometer = () => stopWatch && isFaceMatch;

  useEffect(() => {
    if (isFaceMatch) {
      isStartLiveness();
    }
  }, [isFaceMatch]);

  useEffect(() => {
    if (isLiveness && open) {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      }
    } else {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
  }, [isLiveness, open]);

  useEffect(() => {
    if (certifaceMessagebase64) setMessageImage(certifaceMessagebase64);
  }, [certifaceMessagebase64]);

  useEffect(() => {
    if (open) {
      startCamera();
    }
  }, [open]);

  useEffect(() => {
    return () => stopCamera();
  }, []);

  useImperativeHandle(ref, () => ({
    takePicture: () => {
      if (isFaceMatch) takePicture();
    },
    stopCamera: () => {
      if (isFaceMatch) onClickClose();
    },
  }));

  useEffect(() => {
    if (open) {
      startCamera();
    }
  }, [cameraType]);

  const startCamera = () => {
    const facingMode = getFacingMode();

    navigator.mediaDevices
      .getUserMedia(facingMode)
      .then(function (stream) {
        window.localStream = stream;
        const video = document.getElementById("liveness");
        if ("srcObject" in video) {
          video.srcObject = stream;
        } else {
          video.src = window.URL.createObjectURL(stream);
        }

        video.onloadedmetadata = function (e) {
          video.play();
        };
      })
      .catch(function (err) {
        console.error(err);
      });
  };

  const stopCamera = () => {
    if (window.localStream) {
      window.localStream.getTracks().forEach((track) => track.stop());
    }

    const video = document.getElementById("liveness");
    if (video) {
      video.srcObject = null;
    }
  };

  const onClickClose = () => {
    setIsFaceMatch(false);
    setMessageImage(null);
    stopCamera();
    handleClose();
  };

  const getFacingMode = () => {
    if (cameraType === FACING_MODES.ENVIRONMENT) {
      return {
        video: {
          facingMode: "environment",
          width: { min: 180, ideal: 553, max: 800 },
          height: { min: 180, ideal: 553, max: 800 },
        },
      };
    } else {
      return {
        video: {
          facingMode: "user",
          width: { min: 180, ideal: 553, max: 800 },
          height: { min: 180, ideal: 553, max: 800 },
        },
      };
    }
  };

  const takePicture = () => {
    var video = document.getElementById("liveness");

    if (video) {
      setIsShowWhiteFlash(true);
      // playClickAudio();
      onTakePhoto(getDataURI(video));

      setTimeout(() => {
        setIsShowWhiteFlash(false);
        if (!doNotCloseAfterTakePicture) {
          onClickClose();
        }
      }, 900);
    } else {
      console.error("Elemento de vídeo não encontrado");
    }
  };

  const Mask = () => {
    const styles = {
      container: {
        display: "flex",
        height: "100%",
        width: "100%",
        zIndex: 9999,
      },
      img: {
        height: "100%",
        width: "100%",
      },
    };

    return (
      <div style={styles.container}>
        <img
          style={styles.img}
          src={themes.components.images.selfieDesktop}
          alt="mask"
        />
      </div>
    );
  };

  const changeCamera = () => {
    stopCamera();

    if (cameraType === FACING_MODES.ENVIRONMENT) {
      setCameraType(FACING_MODES.USER);
    } else {
      setCameraType(FACING_MODES.ENVIRONMENT);
    }
  };

  return open ? (
    <>
      {mask && <Mask />}

      {!disableCloseButton && <St.IconClose size={50} onClick={onClickClose} />}

      {!disableChangeCamButton && (
        <St.ChangeCamera>
          <St.IconChangeCamera size={50} onClick={changeCamera} />
        </St.ChangeCamera>
      )}

      {isLiveness && isFaceMatch === false ? (
        <St.ContainerBtn>
          <Button onClick={() => setIsFaceMatch(true)}>
            Estou pronto para iniciar a biometria facial
          </Button>
        </St.ContainerBtn>
      ) : null}

      {isChronometer && <Chronometer reset={certifaceMessagebase64} />}

      {messageImage && (
        <St.CertifaceMessageSteps
          src={"data:image/png;base64," + messageImage}
        />
      )}

      {!disableTakePictureButton && <St.Button onClick={takePicture} />}

      <WhiteFlash isShowWhiteFlash={isShowWhiteFlash} />

      <St.Camera id="liveness" mirroring={cameraType === FACING_MODES.USER} />
    </>
  ) : (
    <></>
  );
}

export default forwardRef(CameraLending);
